<template>
  <div :class="[`proview-quantity`, size]">
    <a
      :class="{disabled: currentValue <= min}"
      @click="handleClick(-1)"
    >
      <span class="icon iconfont iconminus"></span>
    </a>
    <input
      type="text"
      v-model="currentValue"
      @input="$emit('input', $event.target.value)"
      @change="handleChange($event.target.value)"
      @blur="$emit('blur', $event.target.value)"
    />
    <a
      :class="{disabled: currentValue >= max}"
      @click="handleClick(1)"
    >
      <span class="icon iconfont iconplus"></span>
    </a>
  </div>
</template>

<script>
import '@/styles/components/shared/quantity.scss';
import helper from '@/utils/helper.js';
const prefix = 'cpt-quantity';
export default {
  props: {
    value: {
      type: [String, Number],
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99999999
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      validator (value) {
        return helper.oneOf(value, ['small', 'large']);
      },
      default: 'small'
    }
  },
  data () {
    return {
      prefix,
      currentValue: this.value
    };
  },
  methods: {
    handleClick (val) {
      if (this.disabled) return;
      if ((val < 0 && this.currentValue <= this.min) || (val > 0 && this.currentValue >= this.max)) return;
      this.currentValue += val;
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    },
    handleChange (val) {
      let v = parseInt(val);
      const reg = /^[1-9]+[0-9]*]*$/;
      if (!reg.test(v)) {
        v = this.min;
      }
      if (val >= this.max) {
        v = this.max;
      }
      this.currentValue = v;
      if (this.currentValue === val) return;
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  watch: {
    value (val) {
      this.currentValue = val;
    }
  }
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/shared/Quantity.vue